<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ProductTypeDropdown from "../../components/Business/ProductTypeDropdown.svelte";
  import { initList, load, initDetail, loading, records, pagination, record, save, onDelete, onPageChange } from "./butcher-slaughter-items.store";
  import { slaughterItemDtoSlaughterFields } from "../../utils/TableFields/slaughter-item-dto-slaughter.fields";

  export let slaughterId: number;

  $: isNew = $record != null && $record.oid == 0;
  //$: canSubmit = $record != null && $record.srcQuantity > 0 && !!$record.srcProductTypeId && !!$record.dstProductTypeId && $record.lotNumber != "";
  $: canSubmit = $record != null && $record.srcQuantity > 0 && !!$record.srcProductTypeId && !!$record.dstProductTypeId;

  async function onSubmit() {
    //let _resp: IApiResponse<ISlaughterItem> = await save();
    await save();
    initDetail();
    load();
  }

  function onCancel() {
    initDetail();
    load();
  }

  onMount(() => initList(slaughterId));
</script>

{#if !!slaughterId && !!$record}
  <div class="columns" style="height: unset;">
    <div class="column is-12">
      <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <div class="column is-3">
            <FormField>
              <NumberInput name="Num capi ingresso" placeholder="0" required={true} bind:value={$record.srcQuantity} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <ProductTypeDropdown name="Tipo ingresso" required={true} phaseCode="A" bind:value={$record.srcProductTypeId} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <ProductTypeDropdown name="Tipo uscita" required={true} phaseCode="M" bind:value={$record.dstProductTypeId} />
            </FormField>
          </div>
          <!--
          <div class="column is-3">
            <FormField>
              <Input name="Lotto" placeholder="lotto" required={true} bind:value={$record.lotNumber} />
            </FormField>
          </div>
          -->
        </div>
      </FormLayout>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={slaughterItemDtoSlaughterFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={false}
    deleteEnabled={true}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
{/if}
